<template>
  <el-container>
    <el-header>
      <headerMenu :isWidth="isWidth" :showUserView="showUserView"></headerMenu>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import headerMenu from '../components/headerMenu.vue'
export default {
  components: {
    headerMenu
  },
  data () {
    return {
      fullHeight: document.body.clientHeight,
      showUserView: false,
      isActive: false,
      activeIndex: -1,
      childSelectTitle: '',
      childMouseoverIndex: -1,
      childActiveIndex: 0,
      tabbarMenuItem: 'tabbar-menu-item',
      childLeftimg: '',
      childLeftDesc: '',
      seleTabChildList: [],
      nowMenuList: [],
      lastMenuList: [],
      screenWidth: document.body.clientWidth,
      isWidth: true // 宽窄屏幕切换
    }
  },
  watch: {
    screenWidth: {
      handler: function (val) {
        if (val < 850) {
          this.isWidth = false
        } else {
          this.isWidth = true
        }
      },
      immediate: true
    }
  },
  mounted () {
    if (localStorage.getItem('Authorization')) {
      this.showUserView = true
    }
    this.fullHeight = document.documentElement.clientHeight
    this.screenWidth = document.body.clientWidth
    this.nowMenuList = this.menuList
    window.onresize = () => {
      return (() => {
        this.fullHeight = document.documentElement.clientHeight
      })()
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
      })()
    }
  }
}
</script>

<style lang="less" scoped>
.el-main::-webkit-scrollbar {
  display: none;
}
.el-main {
  background-color: #eaedf1;
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-y: auto;
  // overflow-y: hidden;
  height: calc(100vh - 120px);
}
.el-header {
  position: relative;
  height: 120px !important;
  padding: 0 !important;
}
.topBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
}
.top-tabview {
  width: 1000px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: rgb(255, 255, 255);
  // position: fixed; /*固定在顶部*/
  // top: 0; /*离顶部的距离为0*/
}
.top-leftlogo {
  width: 171px;
  height: 40px;
  display: flex;
  // margin-top: 9px;
  // position: absolute; /*固定在顶部*/
  // top: 6px;
  margin-left: 10px;
  .top-leftlogo-image {
    width: 171px;
    height: 40px;
  }
}
.right-menu-backview {
  width: 820px;
  height: 120px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .right_tabbar_menuview {
    width: 790px;
    height: 120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
  .top-right-headView {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 15px;
  }
}
.normal_type {
  padding: 0px 20px;
  font-size: 10px;
  color: black;
  text-align: center;
  height: 40px;
  line-height: 30px;
  background-color: white;
  border: 0;
}
.chose_type {
  padding: 0px 20px;
  font-size: 10px;
  color: rgb(200, 24, 24);
  text-align: center;
  height: 30px;
  line-height: 30px;
  background-color: white;
  border: 0;
}

.menu-button-class {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  background-image: url(../assets/images/right-menu-img.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
}

.tabbar_child_childmenu_backview {
  position: absolute;
  top: 40px;
  z-index: 1002;
  // padding-top: 20px;
}
.tabbar_child_childmenu {
  // width: 640px;
  margin-top: 20px;
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  // height: 140px;
  border-radius: 40px;
}
.child-left-imgview {
  width: 148px;
  height: auto;
  border-radius: 12px;
}
.child-left-descview {
  color: white;
  width: 330px;
  // height: 120px;
  margin: 15px 10px;
  text-align: left;
  font-size: 12px;
}
.child-center-lineview {
  width: 1px;
  background-color: white;
  height: 120px;
}
.child-right-itemview {
  // width: 150px;
  padding: 15px 10px;
  // height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.child-item-selectmenu {
  width: 100%;
  text-align: left;
  color: rgb(200, 24, 24);
  font-size: 12px;
  line-height: 20px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}
.child-item-unselectmenu {
  width: 100%;
  text-align: left;
  color: rgb(255, 255, 255);
  font-size: 12px;
  line-height: 20px;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}
</style>
